module.exports = __webpack_public_path__ + "img/IMG_1458_L_BlackMatted.bc0e9b44.jpg";